import { Circle, Path } from "react-native-svg";

import { type IconProps, LineIcon } from "./LineIcon";

export function ProfileIcon(props: IconProps) {
  return (
    <LineIcon {...props}>
      <Circle cx="12" cy="8" r="4" />
      <Path d="M4 21a8 8 0 0 1 16 0" />
    </LineIcon>
  );
}
